export enum EventTimeline {
  CURRENT = 'current',
  UPCOMING = 'upcoming',
  PAST = 'past',
}
